import { render, staticRenderFns } from "./playerTv.vue?vue&type=template&id=674b6559&scoped=true"
import script from "./playerTv.vue?vue&type=script&lang=js"
export * from "./playerTv.vue?vue&type=script&lang=js"
import style0 from "./playerTv.vue?vue&type=style&index=0&id=674b6559&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674b6559",
  null
  
)

export default component.exports